export default "__VITE_ASSET__CSjeXqdc__"